/**
 * Stored program names include the uploader's full player ID or its eight-character prefix.
 * Display labels omit that suffix. Keys and leaderboard matching keep the raw label.
 */

const playerSuffix = /-ply_[0-9a-f]{8}(?:-[0-9a-f]{4}){3}-[0-9a-f]{12}/gi;
/**
 * The current suffix: `-` and exactly 8 lowercase hex characters ending the name part (before `:vN` or the end).
 * A real name can end that way too, so only a tail that looks like a UUID prefix counts: it has a digit and a
 * letter (a date like `run-20261022` or a word like `agent-deadbeef` is a name).
 */
const shortSuffix = /(?<=[^\s:])-([0-9a-f]{8})(?=:v\d|\s|$)/g;
const hasDigitAndLetter = (hex: string) =>
  /[0-9]/.test(hex) && /[a-f]/.test(hex);
/** `towerless-ply_<uuid>:v1` shown as `towerless:v1`. */
export const plainName = (label: string): string =>
  label
    .replace(playerSuffix, "")
    .replace(shortSuffix, (all, hex: string) =>
      hasDigitAndLetter(hex) ? "" : all,
    );

/** `towerless-ply_<uuid>:v1` read aloud as `towerless v1`. */
export const spokenName = (label: string): string =>
  plainName(label).replace(/:v(\d+)$/, " v$1");
